import { render, staticRenderFns } from "./ServiceNeedOptionsManage.vue?vue&type=template&id=54530f7e&scoped=true"
import script from "./ServiceNeedOptionsManage.vue?vue&type=script&lang=js"
export * from "./ServiceNeedOptionsManage.vue?vue&type=script&lang=js"
import style0 from "./ServiceNeedOptionsManage.vue?vue&type=style&index=0&id=54530f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54530f7e",
  null
  
)

export default component.exports